import { useState } from "react";
import PageLayout from "../../components/PageLayout";
import { employeeFlagOptions } from "../../options/employeFlagOptions";
import { getApi, postApi } from "../../utils/api";
import { API_DOWNLOAD_LEAVE_REPORT } from "../../config/Endpoints";
import Cookies from "js-cookie";
import { showError } from "../../v2/utils/toast.ts";
import DatePicker from "react-datepicker";
import { formatDate, formatToDateOnly } from "../../utils/helpers";
import { getApiErrorMessage } from "../../v2/utils/api-error-message.ts";

const DownloadLeaveReport = ({ title, description }) => {
  const [isLoading, setIsLoading] = useState(false);
  const formDataInitialState = {
    fromDate: "",
    toDate: "",
    employeeFlag: employeeFlagOptions[0].value,
  };
  const [formData, setFormData] = useState(formDataInitialState);
  const accessToken = Cookies.get("accessToken");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true);

      const res = await fetch(API_DOWNLOAD_LEAVE_REPORT + `?from=${formData.fromDate}&to=${formData.toDate}&type=${formData.employeeFlag}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/vnd.ms-excel",
        },
      });

      if (!res.ok) {
        const contentType = res.headers.get("Content-Type");

        if (contentType && contentType.includes("application/json")) {
          const errorData = await res.json();
          showError(errorData.message || "Download failed.");
        }
        return;
      }

      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Leaves_Report_${formData.employeeFlag}_${formData.fromDate}_to_${formData.toDate}`;
      link.click();
      URL.revokeObjectURL(url);
      handleReset();
    } catch (err) {
      showError(
        getApiErrorMessage(
          err,
          "Something went wrong, please try again later",
        ),
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleReset = () => {
    setFormData(formDataInitialState);
  };

  return (
    <PageLayout title={title} description={description} isLoading={isLoading}>
      <form id="assign-asset" onSubmit={handleSubmit}>
        <div className="card">
          <div className="inputs column-gap-2">
            <div className="row mt-4">
              <div className="col-md-2"></div>
              <div className="col-md-2 d-flex align-items-center">
                <label htmlFor="month" className="has-asterisk">
                  From Date
                </label>
              </div>
              <div className="col-md-5">
                <div className="input-group">
                  <DatePicker
                    name="fromDate"
                    placeholderText="mm/dd/yyyy"
                    selected={formData.fromDate}
                    onChange={(date) => {
                      setFormData((state) => ({
                        ...state,
                        fromDate: formatToDateOnly(date),
                      }));
                    }}
                    toggleCalendarOnIconClick
                    maxDate={(() => {
                      const futureDate = new Date();
                      futureDate.setMonth(futureDate.getMonth() + 7);
                      futureDate.setDate(0);

                      const toDate = new Date(formData.toDate);

                      return toDate < futureDate ? toDate : futureDate;
                    })()}
                    minDate={(() => {
                      const date = new Date();
                      date.setMonth(date.getMonth() - 11);
                      date.setDate(1);
                      date.setHours(0, 0, 0, 0);
                      return date;
                    })()}
                    autoComplete="off"
                    showIcon
                    required
                  />
                </div>
              </div>
              <div className="col-md-3"></div>
            </div>

            <div className="row mt-1">
              <div className="col-md-2"></div>
              <div className="col-md-2 d-flex align-items-center ">
                <label htmlFor="year" className="has-asterisk">
                  To Date
                </label>
              </div>
              <div className="col-md-5">
                <div className="input-group">
                  <DatePicker
                    name="toDate"
                    placeholderText="mm/dd/yyyy"
                    selected={formData.toDate}
                    onChange={(date) => {
                      setFormData((state) => ({
                        ...state,
                        toDate: formatToDateOnly(date),
                      }));
                    }}
                    minDate={(() => {
                      const pastDate = new Date();
                      pastDate.setMonth(pastDate.getMonth() - 11);
                      pastDate.setDate(1); 
                      pastDate.setHours(0, 0, 0, 0);

                      const fromDate = new Date(formData.fromDate);

                      return fromDate > pastDate ? fromDate : pastDate;
                    })()}
                    maxDate={(() => {
                      const date = new Date();
                      date.setMonth(date.getMonth() + 7);
                      date.setDate(0);
                      return date;
                    })()}
                    toggleCalendarOnIconClick
                    autoComplete="off"
                    showIcon
                    required
                  />
                </div>
              </div>
              <div className="col-md-3"></div>
            </div>

            <div className="row mt-1">
              <div className="col-md-2"></div>
              <div className="col-md-2 d-flex align-items-center">
                <label htmlFor="employee-flag" className="has-asterisk">
                  Employee Flag
                </label>
              </div>
              <div className="col-md-5">
                <div className="input-group">
                  <select id="employee-flag" required name="employeeFlag" value={formData.employeeFlag} onChange={handleChange}>
                    {employeeFlagOptions.map(({ label, value }) => (
                      <option key={value} value={value}>
                        {label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3"></div>
            </div>
          </div>
          <br />

          <div className="action text-center">
            <button className="btn btn-secondary" type="button" onClick={handleReset}>
              Reset
            </button>
            <button type="submit" className={isLoading ? "theme-button disabled ms-2 " : "theme-button ms-2 "}>
              Download
            </button>
          </div>
        </div>
      </form>
    </PageLayout>
  );
};

export default DownloadLeaveReport;
